import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./FeuE8Documentation.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { FeuECommonColumns } from "../../FeuConstants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuE8Documentation = forwardRef(({ FeuE8DocumentationData, refetchMonitoringData,vesselMstId }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (FeuE8DocumentationData) {
            reset(prev => ({ ...prev, e8: FeuE8DocumentationData }));
        }
    }, [FeuE8DocumentationData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("e8");
        const payload = {
            ...FeuECommonColumns.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const FeuE8Documentation = await callApi({
                method: "POST",
                url: API_ROUTES.E8(vesselMstId),
                data: payload,
            });
            if (FeuE8Documentation?.isSuccess) {
                emitToasterMsg("success", "Table E.8", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, e8: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table E.8", FeuE8Documentation?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table E.8", error?.errorMessage);
        }
    };

    return (
        <div className="e8-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Documentation
                    </h6>
                </MDBCol>
            </MDBRow>

            {FeuECommonColumns.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`e8.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`e8_${name}`}
                                    className="textarea-resize"
                                    value={field.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="feue8_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save
                </Button>
            </div>
        </div>
    );
});

export default FeuE8Documentation;
